import { useEffect, useRef } from 'react';

import { getScrollableParents } from './utils';

interface AutoCloseProps {
  children: React.ReactNode;
  tooltip: Element | null;
  wrapper: Element | null;
  close: () => void;
}

const AutoClose = ({ children, tooltip, wrapper, close }: AutoCloseProps) => {
  const canClose = useRef<boolean>();
  const timer = useRef<number>();

  useEffect(() => {
    if (!tooltip || !wrapper) return;

    const mouseLeave = () => {
      canClose.current = true;
      if (timer.current) clearTimeout(timer.current);

      timer.current = Number(
        setTimeout(() => {
          if (canClose.current) close();
        }, 2000),
      );
    };

    const mouseEnter = () => {
      canClose.current = false;
    };

    //first hover and showup should start timer and set canClose to false
    mouseLeave();
    mouseEnter();

    [tooltip, wrapper].forEach((el) =>
      el.addEventListener('mouseenter', mouseEnter),
    );
    [tooltip, wrapper].forEach((el) =>
      el.addEventListener('mouseleave', mouseLeave),
    );

    return () => {
      if (timer.current) clearTimeout(timer.current);
      [tooltip, wrapper].forEach((el) =>
        el.removeEventListener('mouseenter', mouseEnter),
      );
      [tooltip, wrapper].forEach((el) =>
        el.removeEventListener('mouseleave', mouseLeave),
      );
    };
  }, [tooltip, wrapper]);

  useEffect(() => {
    const containers = getScrollableParents(wrapper);
    containers.forEach((el) => el.addEventListener('scroll', close));
    return () =>
      containers.forEach((el) => el.removeEventListener('scroll', close));
  }, [wrapper]);

  return <>{children}</>;
};

export default AutoClose;
